import {
    FETCH_FORM_STARTED,
    FETCH_FORM_ERROR,
    FETCH_FORM_INSTANCES_SUCCESS,
    FETCH_FORM_FIELDS_SUCCESS,
    FETCH_FORM_DATA_SUCCESS,
    Column,
    FormDataItem,
    PUT_FORM_DATA,
    POST_FORM_DATA
  } from "./types";

export const fetchFormStarted = () => ({
    type : FETCH_FORM_STARTED,
})
export const fetchFormStartedError = (error:any) => ({
    type : FETCH_FORM_ERROR,
    error
})
export const fetchFormFieldsSuccess = (formId: number,formTitle: string,formFields: FormDataItem[]) => ({
    type        : FETCH_FORM_FIELDS_SUCCESS,
    formId,
    formTitle,
    formFields
})
export const fetchFormDataSuccess = (formId: number,id: number,formTitle: string,formDataFields: FormDataItem[], signature?:any) => ({
    type        : FETCH_FORM_DATA_SUCCESS,
    id,
    formId,
    formTitle,
    formDataFields,
    signature
})
export const fetchFormInstancesSuccess = (formId: number, formTitle: string, description: string, dataSource: any[],columns: Column[]) => ({
    type        : FETCH_FORM_INSTANCES_SUCCESS,
    formId,
    formTitle,
    description,
    dataSource,
    columns
})
export const putFormData = (id: number,formId: number,formData: any) => ({
    type        : PUT_FORM_DATA,
    id,
    formId,
    formData
})
export const postFormData = (formId: number,formData: any) => ({
    type        : POST_FORM_DATA,
    formId,
    formData
})